import { css } from '@emotion/core';

const infoMessageContainerOverrides = css`
  padding: 16px;
  gap: 8px;
  background: #faf8f5;
  border-radius: 6px;
  margin-bottom: 12px;
`;

const infoMessageOverrides = css`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #001435;
`;

export { infoMessageOverrides, infoMessageContainerOverrides };
